import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import Button from '../../../UI/Button/Button';
import Translation from '../../lang/Translation';
import HelperDetailList from '../ui/HelperDetailList/HelperDetailList';
import HelperDetailListItem from '../ui/HelperDetailList/HelperDetailListItem';
import koreanPassportIcon from '../ui/svg/korean-passport.svg';
import koreanPCCCIcon from '../ui/svg/korean-pccc.svg';
import openLinkIcon from '../ui/svg/openLink.svg';

const buttonLinkOverride = {
  color: '#333',
  fontFamily: 'Helvetica',
  letterSpacing: 0,
  fontWeight: 700,
};

const useStyles = createUseStyles({
  button: {
    ...buttonLinkOverride,
    '&:hover, &:visited': {
      color: '#333',
      letterSpacing: 0,
      fontWeight: 700,
    },
  },
  icon: {
    paddingBottom: 6,
    paddingLeft: 3,
  },
});

function ResidentIDHelper(props) {
  const classes = useStyles();
  
  const HelperLink = () => (
    <Button
      link
      href="https://unipass.customs.go.kr/csp/persIndex.do"
      id="ResidentIDHelper__PCCCLink"
      className={classes.button}
    >
      <Translation>checkout.address.field.label.residentId.pcc.link</Translation>
      <img className={classes.icon} src={openLinkIcon} alt="" />
    </Button>
  );
  
  return (
    <HelperDetailList>
      <HelperDetailListItem
        icon={props.isForeignCitizen ? koreanPCCCIcon : koreanPassportIcon}
        info={Translation.getText(props.isForeignCitizen
          ? 'checkout.address.field.label.residentId.pcc.helpContent'
          : 'checkout.address.field.label.residentId.passport.helpContent')}
        isOverlay={props.isOverlay}
        link={props.isForeignCitizen && <HelperLink />}
      />
    </HelperDetailList>
  );
}

ResidentIDHelper.defaultProps = {
  isOverlay: false,
  isForeignCitizen: false,
};

ResidentIDHelper.propTypes = {
  isOverlay: PropTypes.bool,
  isForeignCitizen: PropTypes.bool,
};

export default ResidentIDHelper;
